// /sign-up — mirror of routes/sign-in.tsx (see that file's header for the
// full rationale on why a single `/$` splat route covers both the bare
// path and Clerk's own path-routed sub-steps). Public, no `_authed` guard.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const SignUpPage = lazy(() => import('@/app/sign-up/page'));

export const signUpSplatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sign-up/$',
  component: SignUpPage,
});
